import React, { Component } from 'react'
import { connect } from 'react-redux'

import { selectors as NotesSelectors } from 'data/notes'
import {
  getSnapshotAt,
  getVersionBefore,
  createDecoratedSnapshotBetweenVersions,
} from 'lib/history-utils'

import Editor from './Editor'

const getDecoratedSnapshot = (history, nVersionNum) => {
  const oVersion = getVersionBefore(nVersionNum, history)
  const oVersionNum = oVersion && oVersion.get('to')
  return createDecoratedSnapshotBetweenVersions({
    oVersionNum,
    nVersionNum,
    history,
  })
}

class NotesHistoryEditor extends Component {
  render() {
    const {
      noteTitle,
      history,
      activeVersionNum,
      showHistoryDecorators,
    } = this.props
    const snapshot = showHistoryDecorators
      ? getDecoratedSnapshot(history, activeVersionNum)
      : getSnapshotAt(history, activeVersionNum)

    return (
      <div>
        <div className="note-editor-title bold">{noteTitle}</div>
        <Editor
          showHistoryDecorators={showHistoryDecorators}
          snapshot={snapshot}
          activeVersionNum={activeVersionNum}
        />
      </div>
    )
  }
}

export default connect((state, { noteId }) => ({
  noteTitle: NotesSelectors.getNote(state, noteId).get('title'),
}))(NotesHistoryEditor)
